module.exports = __webpack_public_path__ + "static/media/Orange_Button@3x.05a09b93.png";